import { create } from 'zustand';

interface EmailEntryState {
  emails: string[];
  setEmail: (email: string) => void;
  addEmails?: (emails: string[]) => void;
  removeEmail?: (email: string) => void;
  addEmail?: (email: string) => void;
}

export const useEmailEntryStore = create<EmailEntryState>((set) => ({
  emails: [],
  setEmail: (email) => set((state) => ({ emails: [...state.emails, email] })),
  addEmails: (emails) => set((state) => {
      const newEmails = emails.filter(email => !state.emails.includes(email));
      return { emails: [...state.emails, ...newEmails] };
    }
  ),
  removeEmail: (email) => set((state) => {
    return { emails: state.emails.filter(e => e !== email) };
  }),
  addEmail: (email) => set((state) => {
    if (!state.emails.includes(email)) {
      return { emails: [...state.emails, email] };
    }
    return state;
  })
}));


